import type { Client } from "../client";
import type { RetentionDefaultConfigurationResource } from "../resources/retentionDefaultConfigurationResource";
import { ConfigurationRepository } from "./configurationRepository";
export class RetentionDefaultConfigurationRepository extends ConfigurationRepository<RetentionDefaultConfigurationResource> {
    constructor(client: Client) {
        super("RetentionDefaultConfiguration", client);
    }
}
